import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/auto-verkaufen/kaernten/Kaernten.js");
